import { FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class InputErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null): boolean {
    return !!(control && control.invalid);
  }
}
